import React from "react";

import "./Post.css";
import "./Blog.css";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import axios from 'axios';
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";


const Post = () => {
  const { t } = useTranslation();

  const lang = i18n.language;
  const [post, setPost] = React.useState([]);
  const [posts, setPosts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const apiUrl = 'https://docs.ngen-group.eu/api/';

  const language = lang.substring(0, 2);

  const formatPostDate = (dateString, language) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const options = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Intl.DateTimeFormat(language, options).format(date);
  };

  const { slugAndId } = useParams();
  const [slug, id] = slugAndId.split(/-(?=\d+$)/);

  React.useEffect(() => {
    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${apiUrl}posts/` + id,
      headers: {
        'Authorization': 'Bearer jmLIFRUUGy9y7TmI7EfTBMmkYRt6YVajU0iLZMM7e9d64afa'
      }
    };

    const config2 = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${apiUrl}posts?lang=${language}`,
      headers: {
        'Authorization': 'Bearer jmLIFRUUGy9y7TmI7EfTBMmkYRt6YVajU0iLZMM7e9d64afa'
      }
    }

    axios.request(config)
      .then(response => {
        const post = response.data;

        setPost(post);
        setLoading(false);

      })
      .catch(error => {
        console.error('Error fetching posts:', error);
      });

    axios.request(config2)
      .then(response => {
        let posts = response.data;

        // Remove the current post
        posts = posts.filter(p => p.id !== id);

        // Shuffle and pick 2 random posts
        const shuffled = posts.sort(() => 0.5 - Math.random());
        const selected = shuffled.slice(0, 2);

        setPosts(selected);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching posts:', error);
      });

  }, [language]);

  // Separate latest post and other posts
  document.title = post.map(post => (post.title));
  return (
    <>
      <div className="UIPost">
        {post.map((post) => (
          <>
            <div className="container-fluid background">
              <div className="container">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-7 blog-header">
                    <div className="heading">
                      <h2>{formatPostDate(post.created_at, language)}</h2>
                      <h1>{post.title}</h1>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="container content postContent">
              <div dangerouslySetInnerHTML={{ __html: (post.content) }} />
            </div>



            <div className="container-fluid">
              <div className="container content postContent py-3 mt-1 postfooter">
                <Link to={t('url.blog')} className="btn-primary" activeClassName="active" exact>{t('blog.all_articles')}</Link>
                <a href={'https://www.linkedin.com/cws/share?url=' + `${t('url.post')}/${post.slug}-${post.id}`} className="btn-primary socialshare" target="_blank" rel="noopener noreferrer"><img width="20px" src="/images/linkedinIcon.svg" /></a>
              </div>
            </div>

            <div className="container-fluid">
              <div className="container content postContent my-5">
                {posts.length > 0 && (
                  <>
                    <div className=" text-start mb-4">
                      <h1>{t('blog.related')}</h1>
                    </div>
                    <div className="row posts">
                      {posts.map((singlePost, index) => (
                        <div className="col-lg-4 col-md-6 col-sm-12 post" key={index}>
                          <a href={`${t('url.post')}/${singlePost.slug}-${singlePost.id}`} className="post-content">
                            <img src={`https://${singlePost.image}`} alt={`${singlePost.title}`} />
                            <div className="date">{formatPostDate(singlePost.created_at, language)}</div>
                            <h4>{singlePost.title}</h4>
                            <p>{singlePost.short_description}</p>
                          </a>
                        </div>
                      ))}
                    </div>
                  </>
                )}
              </div>
            </div>
          </>
        ))}

      </div>
    </>
  );
};

export default Post;
